'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Alert = require('./Alert');

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Alert2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Alert/index.js
// module id = 255
// module chunks = 11